import React from 'react';
import { Helmet } from 'react-helmet-async';
import html2pdf from 'html2pdf.js';
import { sendGAPageview } from '../utils/gaConsent';
import PrivacyContentFromMarkdown from '../components/Privacy/PrivacyContentFromMarkdown';
import $ from 'jquery';
import LegalDocumentLayout from '../components/Legal/LegalDocumentLayout';

export default function Privacy() {
  $('.popover').hide();
  sendGAPageview({
    hitType: 'pageview',
    page: '/Privacy-policy',
    title: 'Privacy Policy',
  });

  const downloadSummary = () => {
    const element = document.getElementById('printer');
    if (!element) return;
    element.classList.add('pdf-mode');
    const opt = {
      margin: [20, 40, 40, 20] as [number, number, number, number],
      filename: 'privacy-policy.pdf',
      image: { type: 'jpeg' as const, quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' as const },
      pagebreak: {
        mode: ['avoid-all', 'css', 'legacy'],
      },
    };
    html2pdf()
      .set(opt)
      .from(element)
      .save()
      .then(() => {
        element.classList.remove('pdf-mode');
      });
  };

  const sections = [
    { id: 'section1', number: '01', label: 'Data controller' },
    { id: 'section2', number: '02', label: 'Data processed, legal basis and storage' },
    { id: 'section4', number: '03', label: 'Data disclosure' },
    { id: 'section5', number: '04', label: 'International transfer' },
    { id: 'section7', number: '05', label: 'Security measures' },
    { id: 'section8', number: '06', label: 'Your rights' },
    { id: 'section9', number: '07', label: 'General' },
  ];

  const contactCard = {
    title: 'Data Protection Contact',
    email: 'dataprotection@disgenet.com',
    phone: '933037654',
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>DISGENET: Privacy Policy</title>
        <meta
          name="description"
          content="This Privacy Policy explains our practices regarding the use of personal data collected and processed through our website, contacts with third parties and the provision of services."
        />

        {/* Open Graph Tags for LinkedIn */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.disgenet.com/Privacy-policy" />
        <meta property="og:title" content="DISGENET: Privacy Policy" />
        <meta
          property="og:description"
          content="MedBioinformatic Solutions SL (“MedBio”, the “Company”, or “we/us”), is committed to protecting the privacy of all users (“You/r”) of our website and services."
        />
      </Helmet>

      <section>
        <link rel="canonical" href="/Privacy-policy" />
        <LegalDocumentLayout
          heroTag="Privacy Policy"
          heroTitle={
            <>
              Personal data <em>processing</em> and rights
            </>
          }
          heroSubtitle="Understand how we collect, use, store and protect your personal data when you use DISGENET."
          sections={sections}
          contact={contactCard}
          onDownload={downloadSummary}
        >
          <PrivacyContentFromMarkdown />
        </LegalDocumentLayout>
      </section>
    </React.Fragment>
  );
}
